import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { ErrorScreen } from '@/components/ui/ErrorScreen'

// Router-level fallback for errors that happen outside (or above) the app
// shell — e.g. a crash while loading an auth page, or in AppLayout itself.
// Errors thrown by individual pages are caught first by the ErrorBoundary
// wrapping <Outlet /> in AppLayout, which keeps the sidebar usable; this is
// the last resort when there's no layout left to render inside.
export function RouteErrorPage() {
  const error = useRouteError()

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <ErrorScreen
        title="Page not found"
        message="The page you're looking for doesn't exist or may have moved."
      />
    )
  }

  return (
    <ErrorScreen
      message="An unexpected error occurred and this page couldn't be displayed."
      onRetry={() => window.location.reload()}
    />
  )
}
